export default (post) => ({
    post,
    init() {
    }
});